$(document).ready(function() {
    const productSwiper = new Swiper('.product-swiper', {
      direction: 'horizontal',
      speed: 1000,
      spaceBetween: 30,
      autoplay: false,
      breakpoints: {
        320: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1242: {
          slidesPerView: 5.5,
          spaceBetween: 40
        }
      }
    })
  })